import { render, staticRenderFns } from "./DieticianUploadsStatus.vue?vue&type=template&id=2a1ea712&"
import script from "./DieticianUploadsStatus.vue?vue&type=script&lang=js&"
export * from "./DieticianUploadsStatus.vue?vue&type=script&lang=js&"
import style0 from "./DieticianUploadsStatus.vue?vue&type=style&index=0&id=2a1ea712&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports